import { Component, effect, inject, signal } from '@angular/core';
import { ModalComponent } from '../../../../shared/ui/modal/modal.component';
import { QrCodeComponent } from '../qr-code/qr-code.component';
import { ModalService } from '../../../../shared/utils/services/modal.service';
import { OrgService } from '../../../../shared/services/org.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'qwiko-wifi-qrcode',
  imports: [ModalComponent, QrCodeComponent, TranslocoModule],
  templateUrl: './wifi-qrcode.component.html',
  styleUrl: './wifi-qrcode.component.scss',
})
export class WifiQRCodeComponent {
  modalService = inject(ModalService);
  orgService = inject(OrgService);

  wifiLinkEffect = effect(() => {
    if (
      this.orgService.org()?.wifi_name &&
      this.orgService.org()?.wifi_password
    ) {
      this.link.set(
        `WIFI:T:WPA;S:${this.orgService.org()?.wifi_name};P:${this.orgService.org()?.wifi_password};H:false;;`,
      );
    }
  });
  link = signal<string>('');

  back() {
    this.modalService.close('wifi-qr-code');
  }
}
